/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "../../../../redux/store";
import { updateProfile, updateProfileVerifyOtp } from "../../../../redux/slices/user";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Snackbar,
  Alert,
  Typography,
  Box,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import ProfileButton from "../../../../components/buttonWithArrow/profileButton";

const countries = [
  { code: 'AD', label: 'Andorra', phone: '376', maxlength: '9' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971', maxlength: '9' },
  { code: 'AF', label: 'Afghanistan', phone: '93', maxlength: '9' },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268', maxlength: '7' },
  { code: 'AI', label: 'Anguilla', phone: '1-264', maxlength: '7' },
  { code: 'AL', label: 'Albania', phone: '355', maxlength: '8' },
  { code: 'AM', label: 'Armenia', phone: '374', maxlength: '8' },
  { code: 'AO', label: 'Angola', phone: '244', maxlength: '9' },
  { code: 'AQ', label: 'Antarctica', phone: '672', maxlength: '6' },
  { code: 'AR', label: 'Argentina', phone: '54', maxlength: '10' },
  { code: 'AS', label: 'American Samoa', phone: '1-684', maxlength: '7' },
  { code: 'AT', label: 'Austria', phone: '43', maxlength: '10' },
  { code: 'AU', label: 'Australia', phone: '61', suggested: true, maxlength: '9' },
  { code: 'AW', label: 'Aruba', phone: '297', maxlength: '7' },
  { code: 'AX', label: 'Alland Islands', phone: '358', maxlength: '9' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', maxlength: '9' },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387', maxlength: '8' },
  { code: 'BB', label: 'Barbados', phone: '1-246', maxlength: '7' },
  { code: 'BD', label: 'Bangladesh', phone: '880', maxlength: '10' },
  { code: 'BE', label: 'Belgium', phone: '32', maxlength: '9' },
  { code: 'BF', label: 'Burkina Faso', phone: '226', maxlength: '8' },
  // Add more countries here in alphabetical order
  { code: 'BG', label: 'Bulgaria', phone: '359', maxlength: '9' },
  { code: 'BH', label: 'Bahrain', phone: '973', maxlength: '8' },
  { code: 'BI', label: 'Burundi', phone: '257', maxlength: '8' },
  { code: 'BJ', label: 'Benin', phone: '229', maxlength: '8' },
  { code: 'BL', label: 'Saint Barthélemy', phone: '590', maxlength: '9' },
  { code: 'BM', label: 'Bermuda', phone: '1-441', maxlength: '7' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673', maxlength: '7' },
  { code: 'BO', label: 'Bolivia', phone: '591', maxlength: '8' },
  { code: 'BQ', label: 'Bonaire', phone: '599', maxlength: '7' },
  { code: 'BR', label: 'Brazil', phone: '55', maxlength: '11' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', maxlength: '7' },
  { code: 'BT', label: 'Bhutan', phone: '975', maxlength: '8' },
  { code: 'BV', label: 'Bouvet Island', phone: '', maxlength: '' },
  { code: 'BW', label: 'Botswana', phone: '267', maxlength: '8' },
  { code: 'BY', label: 'Belarus', phone: '375', maxlength: '9' },
  { code: 'BZ', label: 'Belize', phone: '501', maxlength: '7' },
  { code: 'CA', label: 'Canada', phone: '1', maxlength: '11' },
  { code: 'CC', label: 'Cocos Islands', phone: '61', maxlength: '9' },
  { code: 'CD', label: 'Democratic Republic of the Congo', phone: '243', maxlength: '9' },
  { code: 'CF', label: 'Central African Republic', phone: '236', maxlength: '8' },
  { code: 'CG', label: 'Republic of the Congo', phone: '242', maxlength: '9' },
  { code: 'CH', label: 'Switzerland', phone: '41', maxlength: '9' },
  { code: 'CI', label: 'Ivory Coast', phone: '225', maxlength: '8' },
  { code: 'CK', label: 'Cook Islands', phone: '682', maxlength: '5' },
  { code: 'CL', label: 'Chile', phone: '56', maxlength: '9' },
  { code: 'CM', label: 'Cameroon', phone: '237', maxlength: '8' },
  { code: 'CN', label: 'China', phone: '86', maxlength: '13' },
  { code: 'CO', label: 'Colombia', phone: '57', maxlength: '10' },
  { code: 'CR', label: 'Costa Rica', phone: '506', maxlength: '8' },
  { code: 'CU', label: 'Cuba', phone: '53', maxlength: '10' },
  { code: 'CV', label: 'Cape Verde', phone: '238', maxlength: '7' },
  { code: 'CW', label: 'Curaçao', phone: '599', maxlength: '7' },
  { code: 'CX', label: 'Christmas Island', phone: '61', maxlength: '9' },
  { code: 'CY', label: 'Cyprus', phone: '357', maxlength: '9' },
  { code: 'CZ', label: 'Czech Republic', phone: '420', maxlength: '9' },
  { code: 'DE', label: 'Germany', phone: '49', maxlength: '12' },
  { code: 'DJ', label: 'Djibouti', phone: '253', maxlength: '8' },
  { code: 'DK', label: 'Denmark', phone: '45', maxlength: '8' },
  { code: 'DM', label: 'Dominica', phone: '1-767', maxlength: '11' },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809', maxlength: '11' },
  { code: 'DZ', label: 'Algeria', phone: '213', maxlength: '9' },
  { code: 'EC', label: 'Ecuador', phone: '593', maxlength: '9' },
  { code: 'EE', label: 'Estonia', phone: '372', maxlength: '8' },
  { code: 'EG', label: 'Egypt', phone: '20', maxlength: '10' },
  { code: 'EH', label: 'Western Sahara', phone: '212', maxlength: '9' },
  { code: 'ER', label: 'Eritrea', phone: '291', maxlength: '7' },
  { code: 'ES', label: 'Spain', phone: '34', maxlength: '9' },
  { code: 'ET', label: 'Ethiopia', phone: '251', maxlength: '9' },
  { code: 'FI', label: 'Finland', phone: '358', maxlength: '10' },
  { code: 'FJ', label: 'Fiji', phone: '679', maxlength: '7' },
  { code: 'FK', label: 'Falkland Islands', phone: '500', maxlength: '5' },
  { code: 'FM', label: 'Micronesia', phone: '691', maxlength: '7' },
  { code: 'FO', label: 'Faroe Islands', phone: '298', maxlength: '6' },
  { code: 'FR', label: 'France', phone: '33', maxlength: '10' },
  { code: 'GA', label: 'Gabon', phone: '241', maxlength: '8' },
  { code: 'GB', label: 'United Kingdom', phone: '44', maxlength: '11' },
  { code: 'GD', label: 'Grenada', phone: '1-473', maxlength: '11' },
  { code: 'GE', label: 'Georgia', phone: '995', maxlength: '9' },
  { code: 'GF', label: 'French Guiana', phone: '594', maxlength: '9' },
  { code: 'GG', label: 'Guernsey', phone: '44', maxlength: '10' },
  { code: 'GH', label: 'Ghana', phone: '233', maxlength: '9' },
  { code: 'GI', label: 'Gibraltar', phone: '350', maxlength: '8' },
  { code: 'GL', label: 'Greenland', phone: '299', maxlength: '6' },
  { code: 'GM', label: 'Gambia', phone: '220', maxlength: '7' },
  { code: 'GN', label: 'Guinea', phone: '224', maxlength: '8' },
  { code: 'GP', label: 'Guadeloupe', phone: '590', maxlength: '9' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240', maxlength: '8' },
  { code: 'GR', label: 'Greece', phone: '30', maxlength: '10' },
  { code: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '', maxlength: '' },
  { code: 'GT', label: 'Guatemala', phone: '502', maxlength: '8' },
  { code: 'GU', label: 'Guam', phone: '1-671', maxlength: '11' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245', maxlength: '7' },
  { code: 'GY', label: 'Guyana', phone: '592', maxlength: '7' },
  { code: 'HK', label: 'Hong Kong', phone: '852', maxlength: '8' },
  { code: 'HM', label: 'Heard Island and McDonald Islands', phone: '', maxlength: '' },
  { code: 'HN', label: 'Honduras', phone: '504', maxlength: '8' },
  { code: 'HR', label: 'Croatia', phone: '385', maxlength: '9' },
  { code: 'HT', label: 'Haiti', phone: '509', maxlength: '8' },
  { code: 'HU', label: 'Hungary', phone: '36', maxlength: '9' },
  { code: 'ID', label: 'Indonesia', phone: '62', maxlength: '11' },
  { code: 'IE', label: 'Ireland', phone: '353', maxlength: '10' },
  { code: 'IL', label: 'Israel', phone: '972', maxlength: '9' },
  { code: 'IM', label: 'Isle of Man', phone: '44', maxlength: '10' },
  { code: 'IN', label: 'India', phone: '91', maxlength: '10' },
  { code: 'IO', label: 'British Indian Ocean Territory', phone: '246', maxlength: '7' },
  { code: 'IQ', label: 'Iraq', phone: '964', maxlength: '10' },
  { code: 'IR', label: 'Iran', phone: '98', maxlength: '11' },
  { code: 'IS', label: 'Iceland', phone: '354', maxlength: '7' },
  { code: 'IT', label: 'Italy', phone: '39', maxlength: '11' },
  { code: 'JE', label: 'Jersey', phone: '44', maxlength: '10' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', maxlength: '11' },
  { code: 'JO', label: 'Jordan', phone: '962', maxlength: '9' },
  { code: 'JP', label: 'Japan', phone: '81', maxlength: '11' },
  { code: 'KE', label: 'Kenya', phone: '254', maxlength: '10' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', maxlength: '9' },
  { code: 'KH', label: 'Cambodia', phone: '855', maxlength: '9' },
  { code: 'KI', label: 'Kiribati', phone: '686', maxlength: '5' },
  { code: 'KM', label: 'Comoros', phone: '269', maxlength: '7' },
  { code: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869', maxlength: '11' },
  { code: 'KP', label: 'North Korea', phone: '850', maxlength: '10' },
  { code: 'KR', label: 'South Korea', phone: '82', maxlength: '10' },
  { code: 'KW', label: 'Kuwait', phone: '965', maxlength: '8' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345', maxlength: '11' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', maxlength: '11' },
  { code: 'LA', label: 'Laos', phone: '856', maxlength: '8' },
  { code: 'LB', label: 'Lebanon', phone: '961', maxlength: '8' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758', maxlength: '11' },
  { code: 'LI', label: 'Liechtenstein', phone: '423', maxlength: '9' },
  { code: 'LK', label: 'Sri Lanka', phone: '94', maxlength: '10' },
  { code: 'LR', label: 'Liberia', phone: '231', maxlength: '7' },
  { code: 'LS', label: 'Lesotho', phone: '266', maxlength: '8' },
  { code: 'LT', label: 'Lithuania', phone: '370', maxlength: '8' },
  { code: 'LU', label: 'Luxembourg', phone: '352', maxlength: '9' },
  { code: 'LV', label: 'Latvia', phone: '371', maxlength: '8' },
  { code: 'LY', label: 'Libya', phone: '218', maxlength: '9' },
  { code: 'MA', label: 'Morocco', phone: '212', maxlength: '9' },
  { code: 'MC', label: 'Monaco', phone: '377', maxlength: '9' },
  { code: 'MD', label: 'Moldova', phone: '373', maxlength: '8' },
  { code: 'ME', label: 'Montenegro', phone: '382', maxlength: '8' },
  { code: 'MF', label: 'Saint Martin', phone: '590', maxlength: '9' },
  { code: 'MG', label: 'Madagascar', phone: '261', maxlength: '9' },
  { code: 'MH', label: 'Marshall Islands', phone: '692', maxlength: '7' },
  { code: 'MK', label: 'North Macedonia', phone: '389', maxlength: '8' },
  { code: 'ML', label: 'Mali', phone: '223', maxlength: '8' },
  { code: 'MM', label: 'Myanmar', phone: '95', maxlength: '9' },
  { code: 'MN', label: 'Mongolia', phone: '976', maxlength: '8' },
  { code: 'MO', label: 'Macao', phone: '853', maxlength: '8' },
  { code: 'MP', label: 'Northern Mariana Islands', phone: '1-670', maxlength: '11' },
  { code: 'MQ', label: 'Martinique', phone: '596', maxlength: '9' },
  { code: 'MR', label: 'Mauritania', phone: '222', maxlength: '8' },
  { code: 'MS', label: 'Montserrat', phone: '1-664', maxlength: '11' },
  { code: 'MT', label: 'Malta', phone: '356', maxlength: '8' },
  { code: 'MU', label: 'Mauritius', phone: '230', maxlength: '7' },
  { code: 'MV', label: 'Maldives', phone: '960', maxlength: '7' },
  { code: 'MW', label: 'Malawi', phone: '265', maxlength: '9' },
  { code: 'MX', label: 'Mexico', phone: '52', maxlength: '13' },
  { code: 'MY', label: 'Malaysia', phone: '60', maxlength: '10' },
  { code: 'MZ', label: 'Mozambique', phone: '258', maxlength: '9' },
  { code: 'NA', label: 'Namibia', phone: '264', maxlength: '9' },
  { code: 'NC', label: 'New Caledonia', phone: '687', maxlength: '6' },
  { code: 'NE', label: 'Niger', phone: '227', maxlength: '8' },
  { code: 'NF', label: 'Norfolk Island', phone: '672', maxlength: '6' },
  { code: 'NG', label: 'Nigeria', phone: '234', maxlength: '10' },
  { code: 'NI', label: 'Nicaragua', phone: '505', maxlength: '8' },
  { code: 'NL', label: 'Netherlands', phone: '31', maxlength: '10' },
  { code: 'NO', label: 'Norway', phone: '47', maxlength: '8' },
  { code: 'NP', label: 'Nepal', phone: '977', maxlength: '10' },
  { code: 'NR', label: 'Nauru', phone: '674', maxlength: '7' },
  { code: 'NU', label: 'Niue', phone: '683', maxlength: '4' },
  { code: 'NZ', label: 'New Zealand', phone: '64', maxlength: '10' },
  { code: 'OM', label: 'Oman', phone: '968', maxlength: '8' },
  { code: 'PA', label: 'Panama', phone: '507', maxlength: '8' },
  { code: 'PE', label: 'Peru', phone: '51', maxlength: '9' },
  { code: 'PF', label: 'French Polynesia', phone: '689', maxlength: '6' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675', maxlength: '7' },
  { code: 'PH', label: 'Philippines', phone: '63', maxlength: '10' },
  { code: 'PK', label: 'Pakistan', phone: '92', maxlength: '10' },
  { code: 'PL', label: 'Poland', phone: '48', maxlength: '9' },
  { code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508', maxlength: '6' },
  { code: 'PN', label: 'Pitcairn', phone: '870', maxlength: '15' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', maxlength: '11' },
  { code: 'PS', label: 'Palestinian Territory', phone: '970', maxlength: '10' },
  { code: 'PT', label: 'Portugal', phone: '351', maxlength: '9' },
  { code: 'PW', label: 'Palau', phone: '680', maxlength: '7' },
  { code: 'PY', label: 'Paraguay', phone: '595', maxlength: '9' },
  { code: 'QA', label: 'Qatar', phone: '974', maxlength: '8' },
  { code: 'RE', label: 'Réunion', phone: '262', maxlength: '9' },
  { code: 'RO', label: 'Romania', phone: '40', maxlength: '10' },
  { code: 'RS', label: 'Serbia', phone: '381', maxlength: '10' },
  { code: 'RU', label: 'Russia', phone: '7', maxlength: '11' },
  { code: 'RW', label: 'Rwanda', phone: '250', maxlength: '9' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966', maxlength: '9' },
  { code: 'SB', label: 'Solomon Islands', phone: '677', maxlength: '5' },
  { code: 'SC', label: 'Seychelles', phone: '248', maxlength: '7' },
  { code: 'SD', label: 'Sudan', phone: '249', maxlength: '9' },
  { code: 'SE', label: 'Sweden', phone: '46', maxlength: '11' },
  { code: 'SG', label: 'Singapore', phone: '65', maxlength: '8' },
  { code: 'SH', label: 'Saint Helena', phone: '290', maxlength: '4' },
  { code: 'SI', label: 'Slovenia', phone: '386', maxlength: '8' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', maxlength: '8' },
  { code: 'SK', label: 'Slovakia', phone: '421', maxlength: '9' },
  { code: 'SL', label: 'Sierra Leone', phone: '232', maxlength: '8' },
  { code: 'SM', label: 'San Marino', phone: '378', maxlength: '10' },
  { code: 'SN', label: 'Senegal', phone: '221', maxlength: '9' },
  { code: 'SO', label: 'Somalia', phone: '252', maxlength: '7' },
  { code: 'SR', label: 'Suriname', phone: '597', maxlength: '7' },
  { code: 'SS', label: 'South Sudan', phone: '211', maxlength: '9' },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239', maxlength: '7' },
  { code: 'SV', label: 'El Salvador', phone: '503', maxlength: '8' },
  { code: 'SX', label: 'Sint Maarten', phone: '1-721', maxlength: '11' },
  { code: 'SY', label: 'Syria', phone: '963', maxlength: '9' },
  { code: 'SZ', label: 'Eswatini', phone: '268', maxlength: '8' },
  { code: 'TC', label: 'Turks and Caicos Islands', phone: '1-649', maxlength: '11' },
  { code: 'TD', label: 'Chad', phone: '235', maxlength: '8' },
  { code: 'TF', label: 'French Southern Territories', phone: '', maxlength: '' },
  { code: 'TG', label: 'Togo', phone: '228', maxlength: '8' },
  { code: 'TH', label: 'Thailand', phone: '66', maxlength: '10' },
  { code: 'TJ', label: 'Tajikistan', phone: '992', maxlength: '9' },
  { code: 'TK', label: 'Tokelau', phone: '690', maxlength: '4' },
  { code: 'TL', label: 'East Timor', phone: '670', maxlength: '7' },
  { code: 'TM', label: 'Turkmenistan', phone: '993', maxlength: '8' },
  { code: 'TN', label: 'Tunisia', phone: '216', maxlength: '8' },
  { code: 'TO', label: 'Tonga', phone: '676', maxlength: '5' },
  { code: 'TR', label: 'Turkey', phone: '90', maxlength: '11' },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868', maxlength: '11' },
  { code: 'TV', label: 'Tuvalu', phone: '688', maxlength: '5' },
  { code: 'TW', label: 'Taiwan', phone: '886', maxlength: '10' },
  { code: 'TZ', label: 'Tanzania', phone: '255', maxlength: '10' },
  { code: 'UA', label: 'Ukraine', phone: '380', maxlength: '12' },
  { code: 'UG', label: 'Uganda', phone: '256', maxlength: '9' },
  { code: 'UM', label: 'United States Minor Outlying Islands', phone: '', maxlength: '' },
  { code: 'US', label: 'United States', phone: '1', maxlength: '11' },
  { code: 'UY', label: 'Uruguay', phone: '598', maxlength: '8' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', maxlength: '9' },
  { code: 'VA', label: 'Vatican', phone: '379', maxlength: '10' },
  { code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784', maxlength: '11' },
  { code: 'VE', label: 'Venezuela', phone: '58', maxlength: '10' },
  { code: 'VG', label: 'British Virgin Islands', phone: '1-284', maxlength: '11' },
  { code: 'VI', label: 'U.S. Virgin Islands', phone: '1-340', maxlength: '11' },
  { code: 'VN', label: 'Vietnam', phone: '84', maxlength: '10' },
  { code: 'VU', label: 'Vanuatu', phone: '678', maxlength: '5' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681', maxlength: '6' },
  { code: 'WS', label: 'Samoa', phone: '685', maxlength: '5' },
  { code: 'YE', label: 'Yemen', phone: '967', maxlength: '9' },
  { code: 'YT', label: 'Mayotte', phone: '262', maxlength: '9' },
  { code: 'ZA', label: 'South Africa', phone: '27', maxlength: '11' },
  { code: 'ZM', label: 'Zambia', phone: '260', maxlength: '9' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', maxlength: '9' },
];

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode.toUpperCase().replace(/./g, (char) =>
      String.fromCodePoint(char.charCodeAt(0) + 127397)
    )
    : isoCode;
}

// const PersonalInfo = ({ userDetail }) => {
const PersonalInfo = () => {
  const { userDetail } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const ref0 = useRef();

  const { updateDetail, updateProfileOtpVerifyRes } = useSelector(
    (state) => state.user
  );

  const [validate, setValidate] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchCountryCodeValue, setSearchCountryCodeValue] = useState("");
  const [formLoading, setFormLoading] = useState(true);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [otpData, setOtpData] = useState({
    phone_otp: "",
    email_otp: "",
    phone_otp_verified: false,
  });
  const [receivedOtp, setReceivedOtp] = useState({
    phone_otp: "",
    email_otp: "",
  });
  const [emailEdit, setEmailEdit] = useState(false);
  const [phoneEdit, setPhoneEdit] = useState(false);

  const [defaultCode, setDefaultCode] = useState({
    code: "AE",
    label: "United Arab Emirates",
    phone: "971",
    maxlength: "9",
  });

  const [originalUserInfo, setOriginalUserInfo] = useState({
    name: "",
    email: "",
    countryCode: "",
    mobile: "",
    rslId: "",
  });

  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    countryCode: "",
    mobile: "",
    rslId: "",
  });

  const [errors, setErrors] = useState({ name: "", email: "", mobile: "" });

  // 1 (phone), 2 (email), 3 (both)
  const [verificationType, setVerificationType] = useState(0);

  const handleVerifyOtp = () => {
    let verifyType = verificationType;
    if (verificationType === 3) {
      verifyType = otpData.phone_otp_verified ? 4 : 3;
    }

    const payload = {
      rslId: userInfo.rslId,
      name: userInfo.name,
      email: userInfo.email,
      countryCode: userInfo.countryCode,
      phone: userInfo.mobile,
      type: verifyType,
      dateOfBirth: "",
      gender: "",
      phone_otp:
        verifyType === 4 ? null : parseInt(otpData.phone_otp || 0, 10),
      email_otp:
        verifyType === 3 ? null : parseInt(otpData.email_otp || 0, 10),
    };

    setVerifyLoader(true);
    dispatch(updateProfileVerifyOtp(payload));
  };

  useEffect(() => {
    if (updateProfileOtpVerifyRes && updateProfileOtpVerifyRes !== undefined) {
      if (updateProfileOtpVerifyRes?.status === 1) {
        setOtpDialogOpen(false);
        setShowSuccess(true);
      } else if (updateProfileOtpVerifyRes?.status === 2) {
        // phone verified; continue to email in the “both” flow
        setOtpData((prev) => ({ ...prev, phone_otp_verified: true }));
        setOtpDialogOpen(true);
      } else {
        setErrorMessage(
          updateProfileOtpVerifyRes?.message ||
          "OTP verification failed. Try again."
        );
        setShowError(true);
      }
      setVerifyLoader(false);
    }
  }, [updateProfileOtpVerifyRes]);

  useEffect(() => {
    if (userDetail !== undefined) {
      setUserInfo({
        ...userDetail?.responseData,
        rslId: userDetail?.responseData?.rslId || "",
      });
      setOriginalUserInfo({
        ...userDetail?.responseData,
        rslId: userDetail?.responseData?.rslId || "",
      });
    }
  }, [userDetail]);

  useEffect(() => {
    if (searchCountryCodeValue) {
      const removePlus = searchCountryCodeValue.replace("+", "");
      const match = countries.find((c) => c.phone === removePlus);
      if (match) setDefaultCode(match);
      setUserInfo((p) => ({
        ...p,
        countryCode: searchCountryCodeValue.includes("+")
          ? searchCountryCodeValue
          : `+${searchCountryCodeValue}`,
      }));
      setFormLoading(false);
    }
  }, [searchCountryCodeValue]);

  useEffect(() => {
    const found = countries.find(
      (c) => `+${c.phone}` === userInfo?.countryCode
    );
    if (found) setDefaultCode(found);
  }, [userInfo?.countryCode]);

  const handleValidation = () => {
    const newErrors = {};
    if (!userInfo.name) newErrors.name = "Name is required.";
    else if (userInfo.name.length < 3)
      newErrors.name = "Name must be at least 3 characters.";
    else if (userInfo.name.length > 20)
      newErrors.name = "Name must be no longer than 20 characters.";

    if (!userInfo.email) newErrors.email = "Email is required.";
    else if (!userInfo.email.includes("@"))
      newErrors.email = "Email must contain '@'.";
    else if (!userInfo.email.endsWith(".com"))
      newErrors.email = "Email must end with '.com'.";

    if (!userInfo.countryCode) newErrors.countryCode = "Required *";

    if (!userInfo.mobile) newErrors.mobile = "Required *";
    else if (/^(\d)\1*$/.test(userInfo.mobile))
      newErrors.mobile = "Please enter valid mobile number.";

    return newErrors;
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const newErrors = handleValidation();

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      const obj = {
        rslId: userInfo.rslId,
        email: userInfo.email,
        countryCode: userInfo.countryCode,
        phone: userInfo.mobile,
        name: userInfo.name,
        type: verificationType, // 1 phone, 2 email, 3 both
        dateOfBirth: "",
        gender: "",
      };
      dispatch(updateProfile(obj));
    } else {
      setValidate(true);
      setErrors(newErrors);
    }
  };

  useEffect(() => {
    if (updateDetail && updateDetail !== undefined) {
      if (updateDetail?.status === 1) {
        setShowSuccess(true);
        setEmailEdit(false);
        setPhoneEdit(false);
      } else if (
        updateDetail?.status === 2 ||
        updateDetail?.status === 3 ||
        updateDetail?.status === 4
      ) {
        setErrorMessage(updateDetail?.message);
        setOtpData({ phone_otp: "", email_otp: "" });
        setReceivedOtp({
          phone_otp: updateDetail?.phone_otp,
          email_otp: updateDetail?.email_otp,
        });
        setOtpDialogOpen(true);
      } else {
        setErrorMessage(updateDetail?.message);
        setShowError(true);
      }
      setLoading(false);
    }
  }, [updateDetail]);

  const handleCloseSuccessDialog = () => {
    setShowSuccess(false);
    setOriginalUserInfo(userInfo);
  };

  const handleChangeValue = (e) => {
    const { name, value } = e.target;
    const updated = { ...userInfo };

    if (name === "mobile") {
      updated[name] = value.replace(/[^0-9]/g, "");
    } else if (name === "name") {
      if (value === "" || value.length <= 20) updated[name] = value;
    } else {
      updated[name] = value;
    }

    // determine verificationType
    let type = 0;
    if (updated.email !== originalUserInfo.email) type += 2;
    if (updated.mobile !== originalUserInfo.mobile) type += 1;

    setVerificationType(type);
    setUserInfo(updated);
    setValidate(false);
  };

  const handleReset = () => {
    setEmailEdit(false);
    setPhoneEdit(false);
    setUserInfo(originalUserInfo);
  };

  return (
    <div>
      <div className='edit-icons'>
        <h5>Personal Information</h5>
        {
          !emailEdit && !phoneEdit &&
          <Button
            variant="outlined"
            endIcon={<EditIcon />}
            onClick={() => {
              setEmailEdit(true);
              setPhoneEdit(true);
            }}
            sx={{
              textTransform: "none",
              borderColor: "#0D8196",      // border color
              color: "#0D8196",            // text + icon color
              fontWeight: 600,

              "&:hover": {
                borderColor: "#075f6e",   // hover border color
                backgroundColor: "rgba(13,129,150,0.08)", // soft hover bg
                color: "#075f6e",         // hover text color
              },
            }}
          >
            Edit
          </Button>
        }

      </div>
      <hr class="custom-hr" />
      <form onSubmit={handleUpdate}>
        <div className="col-xl-12">
          <div className="row x-gap-20 y-gap-20">
            {/* Name */}

            <div className="col-12">
              <label className="input-title">User Name</label>
              <TextField
                fullWidth
                placeholder="Enter User Name"
                variant="outlined"
                name="name"
                value={userInfo.name}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                }}
                onChange={handleChangeValue}
              />
              {errors.name ? (
                <p style={{ color: validate ? "red" : "white" }}>{errors.name}</p>
              ) : null}
            </div>

            <div className="col-md-6" style={{ position: "relative" }}>
              <label className="input-title">Email</label>
              <TextField
                fullWidth
                placeholder="Enter your email"
                variant="outlined"
                name="email"
                value={userInfo.email}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                }}
                onChange={handleChangeValue}
                disabled={!emailEdit}
              />
              {errors.email ? (
                <p style={{ color: validate ? "red" : "white" }}>{errors.email}</p>
              ) : null}
            </div>


            {/* <div className="col-12">
            <div className="form-input">
              <input
                type="text"
                required
                name="name"
                value={userInfo.name}
                onChange={handleChangeValue}
              />
              <label className="lh-1 text-16 text-light-1">User Name</label>
            </div>
            {errors.name ? (
              <p style={{ color: validate ? "red" : "white" }}>{errors.name}</p>
            ) : null}
          </div> */}

            {/* Email */}
            {/* <div className="col-md-6">
            <div className="form-input" style={{ position: "relative" }}>
              <input
                type="text"
                required
                name="email"
                value={userInfo.email}
                onChange={handleChangeValue}
                disabled={!emailEdit}
              />
              <label className="lh-1 text-16 text-light-1">Email</label>
              {!emailEdit && !phoneEdit && (
                <EditIcon
                  className="edit-icon"
                  style={{ position: "absolute", right: 0, cursor: "pointer" }}
                  onClick={() => setEmailEdit(true)}
                />
              )}
            </div>
            {errors.email ? (
              <p style={{ color: validate ? "red" : "white" }}>{errors.email}</p>
            ) : null}
          </div> */}

            {/* PHONE NUMBER */}
            <div style={{ flex: 1, position: "relative" }}>
              <label className="input-title">Phone Number</label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  padding: "6px 10px",
                  height: "56px",
                }}
              >
                {/* Fake UAE flag */}
                {/* <span style={{ fontSize: "24px", marginRight: "6px" }}>🇦🇪</span> */}

                {/* COUNTRY CODE */}
                <Autocomplete
                  disableClearable
                  options={countries}
                  disabled={!phoneEdit}
                  ref={ref0}
                  onChange={(e, newValue) =>
                    setSearchCountryCodeValue(newValue.phone)
                  }
                  value={defaultCode}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : `${countryToFlag(option.code)} ${option.code}+${option.phone}`
                  }
                  filterOptions={(options, state) => {
                    return options.filter((item) =>
                      item.label.toLowerCase().includes(state.inputValue.toLowerCase())
                    );
                  }}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <span>{countryToFlag(option.code)}</span>&nbsp;
                      {option.label}({option.code}) +{option.phone}
                    </li>
                  )}
                  sx={{
                    width: "120px",
                    "& .MuiAutocomplete-inputRoot": {
                      padding: 0,
                    },
                    "& input": {
                      fontSize: "16px",
                    },
                  }}
                  slotProps={{
                    paper: { sx: { width: 300 } },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                      }}
                    />
                  )}
                />

                {/* DIVIDER */}
                <div
                  style={{
                    width: "1px",
                    height: "24px",
                    background: "#d8d8d8",
                    margin: "0 14px",
                  }}
                ></div>

                {/* PHONE INPUT */}
                <input
                  type="text"
                  placeholder="xxx xxx xxxx"
                  name="mobile"
                  maxLength={defaultCode ? defaultCode.maxlength : undefined}
                  value={userInfo.mobile}
                  onChange={handleChangeValue}
                  onInput={(e) =>
                  (e.target.value = e.target.value
                    .replace(/[^0-9.]/g, "")
                    .replace(/(\..*)\./g, "$1"))
                  }
                  disabled={!phoneEdit}
                  style={{
                    border: "none",
                    outline: "none",
                    flex: 1,
                    fontSize: "16px",
                  }}
                />
              </div>
              {errors.mobile ? (
                <p style={{ color: validate ? "red" : "white" }}>
                  {errors.mobile}
                </p>
              ) : null}
            </div>

            {/* Phone */}
            {/* <div className="col-md-6">
              <div className="row x-gap-0">
                
                <div className="col-4 border">
                  <label className="lh-1 text-16 text-light-1 px-2">Code</label>
                  <Autocomplete
                    value={defaultCode}
                    name="countryCode"
                    ref={ref0}
                    onChange={(e, newValue) =>
                      setSearchCountryCodeValue(newValue.phone)
                    }
                    freeSolo
                    disableClearable
                    disabled={!phoneEdit}
                    options={countries}
                    autoHighlight
                    getOptionLabel={(option) =>
                      typeof option === "string"
                        ? option
                        : `${option.code}+${option.phone}`
                    }
                    // v5 signature: (props, option)
                    renderOption={(props, option) => (
                      <li {...props}>
                        <span>{countryToFlag(option.code)}</span>&nbsp;
                        {option.label} ({option.code}) +{option.phone}
                      </li>
                    )}
                    slotProps={{
                      paper: { sx: { width: 300 } },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="code"
                        size="small"
                        placeholder="AE+971"
                        required
                        variant="standard"
                        onClick={(p) => (p.target.value = "")}
                        sx={{
                          "& .MuiInputBase-root:before": {
                            borderBottomColor: "transparent",
                          },
                          "& .MuiInputBase-root:hover:before": {
                            borderBottomColor: "transparent",
                          },
                        }}
                      />
                    )}
                  />
                </div>

                
                <div className="col-8">
                  <div className="form-input" style={{ position: "relative" }}>
                    <input
                      type="text"
                      required
                      name="mobile"
                      maxLength={defaultCode ? defaultCode.maxlength : undefined}
                      value={userInfo.mobile}
                      onChange={handleChangeValue}
                      onInput={(e) =>
                      (e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1"))
                      }
                      disabled={!phoneEdit}
                    />
                    <label className="lh-1 text-16 text-light-1">
                      Phone Number
                    </label>
                    {!emailEdit && !phoneEdit && (
                      <EditIcon
                        className="edit-icon"
                        style={{ position: "absolute", right: 0, cursor: "pointer" }}
                        onClick={() => setPhoneEdit(true)}
                      />
                    )}
                  </div>
                  {errors.mobile ? (
                    <p style={{ color: validate ? "red" : "white" }}>
                      {errors.mobile}
                    </p>
                  ) : null}
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex flex-wrap gap-4 pt-30" style={{
          justifyContent: "end"
        }}>
          {(emailEdit || phoneEdit) && !loading && (
            <div className="d-inline-block">
              <Button
                variant="outlined"
                disabled={loading}
                type="button"
                onClick={handleReset}
                sx={{
                  minWidth: "150px",
                  height: "50px",
                  px: "12px",
                  fontWeight: "bold",
                  color: "#333",
                  border: "2px solid var(--color-border)",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.05)",
                    border: "2px solid var(--color-border)",
                  },
                }}
              >
                Reset
              </Button>
            </div>
          )}
          <div className="d-inline-block">
            <button className="save-btn"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) :
                "Save Changes"
              }
            </button>

            {/* <button
              type="submit"
              className="button h-60 px-24 text-white -dark-4 px-20 bg-dark-3 text-white"
              disabled={loading}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                minWidth: "180px",
              }}
            >
              {loading ? (
                <CircularProgress size={20} sx={{ color: "white" }} />
              ) : (
                <>
                  Save Changes
                  <div className="icon-arrow-top-right ml-10" />
                </>
              )}
            </button> */}
          </div>
        </div>

        {/* Success dialog */}
        <Dialog
          open={showSuccess}
          onClose={handleCloseSuccessDialog}
          PaperProps={{
            sx: {
              borderRadius: "12px",
              p: "20px",
              textAlign: "center",
              minWidth: 350,
            },
          }}
        >
          <DialogTitle>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CheckIcon sx={{ color: "#28a745", fontSize: 60 }} />
              <Typography variant="h5" sx={{ mt: 1, fontWeight: "bold" }}>
                Success!
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" color="text.secondary">
              Your profile has been updated successfully.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseSuccessDialog}
              variant="contained"
              className="button h-40 px-24 text-white -dark-4 px-20 bg-dark-3 text-white"
            >
              Okay
            </Button>
          </DialogActions>
        </Dialog>

        {/* OTP dialog */}
        <Dialog open={otpDialogOpen} onClose={() => setOtpDialogOpen(false)}>
          <DialogTitle>OTP Verification</DialogTitle>
          <DialogContent>
            <p>
              {verificationType === 1
                ? "We have sent a verification code to your mobile."
                : verificationType === 2
                  ? "We have sent a verification code to your email."
                  : !otpData.phone_otp_verified
                    ? "We have sent a verification code to your mobile."
                    : "We have sent a verification code to your email."}
            </p>

            <div className="otp-container">
              {(verificationType === 1 ||
                (verificationType === 3 && !otpData.phone_otp_verified)) && (
                  <TextField
                    fullWidth
                    label="Phone OTP"
                    variant="outlined"
                    value={otpData.phone_otp}
                    onChange={(e) =>
                      setOtpData({ ...otpData, phone_otp: e.target.value })
                    }
                    sx={{ mb: 2 }}
                  />
                )}

              {(verificationType === 2 ||
                (verificationType === 3 && otpData.phone_otp_verified)) && (
                  <TextField
                    fullWidth
                    label="Email OTP"
                    variant="outlined"
                    value={otpData.email_otp}
                    onChange={(e) =>
                      setOtpData({ ...otpData, email_otp: e.target.value })
                    }
                  />
                )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleVerifyOtp}
              variant="contained"
              className="button h-40 px-24 text-white -dark-4 px-20 bg-dark-3 text-white"
              disabled={verifyLoader}
            >
              {verifyLoader ? (
                <CircularProgress size={20} sx={{ color: "white" }} />
              ) : (
                "Verify OTP"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Error toast */}
        <Snackbar
          open={showError}
          autoHideDuration={4000}
          onClose={() => setShowError(false)}
        >
          <Alert
            severity="error"
            variant="filled"
            onClose={() => setShowError(false)}
          >
            {errorMessage}
          </Alert>
        </Snackbar>
      </form>
    </div>
  );
};

export default PersonalInfo;
